import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import DetailsHeaderBar from "../components/DetailsHeaderBar";
import DetailSection from "../components/DetailSection";
import { MdUpdate, MdOutlineAssignmentInd } from "react-icons/md";
import { FaRegUserCircle } from "react-icons/fa";
import "../styles/MemberDetails.css";
import { parentsConsentService } from "../services/parentsConsentService";

function ParentsConsentDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const initial = location.state?.consent;
  const [consent, setConsent] = useState(initial || null);

  useEffect(() => {
    const load = async () => {
      if (!initial?.id) {
        return;
      }
      try {
        const fresh = await parentsConsentService.getById(initial.id);
        setConsent(fresh);
      } catch (error) {
        console.error("Failed to load parental consent details", error);
      }
    };
    load();
  }, [initial?.id]);

  if (!consent) {
    return <p style={{ padding: 30 }}>No parental consent data available.</p>;
  }

  const goToEdit = () => {
    navigate("/edit-parental-consent", { state: { consent } });
  };

  const breadcrumbs = [
    { label: "Home", path: "/dashboard" },
    { label: "Manage Parental Consent", path: "/manage-parental-consent" },
    { label: "Parental Consent Details" },
  ];

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Parental Consent Details"
          subtitle="View parental consent submission and review status."
          breadcrumbs={breadcrumbs}
        />

        <DetailSection
          title="Consent Details"
          icon={FaRegUserCircle}
          // showEdit
          onEdit={goToEdit}
          fields={[
            { label: "Consent ID", value: consent.id },
            { label: "User ID", value: consent.user_id },
            { label: "Child full name", value: consent.child_full_name },
            { label: "Date of birth", value: consent.date_of_birth },
            { label: "Parent / guardian", value: consent.parent_guardian_name },
            { label: "Relationship", value: consent.relationship_to_child },
            { label: "Consent date", value: consent.consent_date },
            { label: "Email (provided)", value: consent.email || "N/A" },
            { label: "Signature", value: consent.signature_image_url ? <img src={consent.signature_image_url} alt="Signature" style={{ maxWidth: '200px' }} /> : "N/A" },
          ]}
          // extraActions={
          //   consent.signature_image_url ? (
          //     <a
          //       className="edit-btn"
          //       style={{ padding: "10px 24px", textDecoration: "none" }}
          //       href={consent.signature_image_url}
          //       target="_blank"
          //       rel="noreferrer"
          //     >
          //       View Signature
          //     </a>
          //   ) : null
          // }
        />

        {/* <DetailSection
          title="Review"
          icon={MdUpdate}
          fields={[
            { label: "Status", value: consent.review_status || "pending" },
            { label: "Reviewed at", value: consent.reviewed_at || "N/A" },
            { label: "Reviewed by", value: consent.reviewer?.email || consent.reviewer?.name || "N/A" },
            { label: "Notes", value: consent.review_notes || "N/A" },
          ]}
        /> */}

        <DetailSection
          title="Customer"
          icon={MdOutlineAssignmentInd}
          fields={[
            { label: "Name", value: consent.customers?.name || "N/A" },
            { label: "Email", value: consent.customers?.email || "N/A" },
            { label: "Phone", value: consent.customers?.phone_number || "N/A" },
          ]}
        />
      </div>
    </div>
  );
}

export default ParentsConsentDetails;

